<template>
  <div class="page-container" :style="themeCssVars">
      <nav-bar :showBack="true" :title="$t('历史版本')" :isRoot="false" :isMPA="true"/>
      <div class="item-list">
            <div v-for="(item, index) in historyList" class="item-container" :key="index" @click="clickHistoryItem(item)">
                <div class="item-text" > {{ item.desc }} </div>
                <img class="arrow-right" src="@/icons/arrow_right.png" />
            </div>
      </div>
    </div>
  </template>
<script>
import NavBar from '@/components/NavBar'
import PageBase from '@/mixin/page-base'
import ThemeStyle from '@/mixin/theme-style'

import { protocolList } from '@/api/protocol/index'
import store from '@/store/index'

export default {
  mixins: [PageBase, ThemeStyle],
  components: {
    NavBar
  },
  props: {},
  data () {
    return {
      historyList: [],
      language: ''
    }
  },
  watch: {},
  created () {
  },
  mounted () {
    this.initParamterForProtocol()
    const param = this.$route.query
    const protocolId = param.protocolId
    this.language = param.lang

    const requestParam = {
      protocolId
    }

    this.showLoading(this.$t('正在加载'))
    protocolList(requestParam).then(res => {
      this.dismissLoading()
      if (res?.code === 100) {
        this.historyList = res.mobBaseRes.result
      } else {
        this.showTipPopup(res.desc, this.$t('确定'))
      }
    })
  },
  methods: {
    clickHistoryItem(item) {
      const protocolId = item.protocolId
      const versionId = item.versionId
      const language = this.language
      const region = this.region
      const appId = store.getters.appid
      this.$router.push({
        path: '/protocol-detail',
        query: {
          region,
          protocolId,
          versionId,
          lang: language,
          hideBtn: true,
          appId
        }
      })
    }
  }
}

</script>
  <style scoped lang="less">
  .page-container {
    background: var(--backgroundColor, #ffffff);
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: stretch;
    position: relative;
    height: 100vh;
    font-size: 16px;
    overflow-y: hidden;
    .item-list {
      overflow-y: scroll;
      flex: 1;
      padding: 0px 16px;
      margin-top: 20px;
      .item-container {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        width: 100%;
        box-sizing: border-box;
        padding: 0px 16px;
        height: 64px;
        .item-text {
          font-size: 14px;
          font-weight: 500;
          color: var(--textColor, #2C2C2C);
        }
        .arrow-right {
          width: 24px;
          height: 24px;
        }
      }
    }
  }
  </style>
